/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Sometimes it is enough to have only workflow instance id in request
 * @export
 * @interface CommonRequestDto
 */
export interface CommonRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CommonRequestDto
     */
    workflowInstanceId: string;
}

/**
 * Check if a given object implements the CommonRequestDto interface.
 */
export function instanceOfCommonRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function CommonRequestDtoFromJSON(json: any): CommonRequestDto {
    return CommonRequestDtoFromJSONTyped(json, false);
}

export function CommonRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommonRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
    };
}

export function CommonRequestDtoToJSON(value?: CommonRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

